/** First-time registration — static field lists (Phase 13). */

export const REGISTER_USER_TYPE_RADIO_OPTIONS = [
  {
    value: "lawfirm_user",
    title: "Attorney or law firm staff",
    subtitle: "I work with a law firm",
  },
  {
    value: "individual_pg",
    title: "Professional Guardian (Individual)",
    subtitle: "I am an independent professional guardian",
  },
  {
    value: "corporate_pg",
    title: "Corporate Professional Guardian",
    subtitle: "I am registering for a corporate guardian entity",
  },
  {
    value: "independent_paralegal",
    title: "Independent Paralegal",
    subtitle: "I provide paralegal services to law firms",
  },
  {
    value: "individual_bond_request",
    title: "Individual bond request",
    subtitle: "I need a bond and am not a professional guardian or attorney",
  },
];

export const REGISTER_GUEST_REFERRAL_SOURCES = [
  "Google Search",
  "Referred by a law firm",
  "Referred by a court",
  "Referred by an attorney",
  "Word of mouth",
  "Other",
];

export const REGISTER_POSITION_OPTIONS = ["Attorney", "Paralegal", "Staff"];
